import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ClipLoader from "react-spinners/ClipLoader";

import "./BookingFormStyle.css";
import {
  setEmail,
  setCellphone,
  setCountry,
  setName,
  setTotalPrice,
} from "../bookingsSlice";

import { getFirestore, collection, getDocs } from "firebase/firestore";

const initiatePayment = async (amount) => {
  try {
    const response = await fetch(
      "https://us-central1-yavola-8ca8d.cloudfunctions.net/initiatePayment",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          amount: amount,
        }),
      }
    );

    const data = await response.json();
    if (data.paymentURL) {
      // Redirect the user to the payment gateway for payment
      window.location.href = data.paymentURL;
      return { success: true };
    } else {
      return { success: false };
    }
  } catch (error) {
    console.error("Error initiating payment:", error);
    return { success: false };
  }
};

const BookingForm = () => {
  const dispatch = useDispatch();
  const carAvailabilityDetails = useSelector((state) => state.carAvailability); // get the booking details
  const bookingDetails = useSelector((state) => state.bookings);
  const db = getFirestore();
  const [pricing, setPricing] = useState({});
  const [paymentStatus, setPaymentStatus] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const pricingCollection = collection(db, "pricing");

    getDocs(pricingCollection).then((querySnapshot) => {
      let fetchedPricing = {};
      querySnapshot.forEach((doc) => {
        fetchedPricing[doc.id] = doc.data().pricePerHead;
      });
      setPricing(fetchedPricing);
    });
  }, [db]);

  const totalPrice = pricing[carAvailabilityDetails.session]
    ? pricing[carAvailabilityDetails.session] * carAvailabilityDetails.people
    : 0;

  useEffect(() => {
    dispatch(setTotalPrice(totalPrice));
  }, [totalPrice, dispatch]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true); // Set loading to true when payment initiation starts
    const totalPrice = bookingDetails.totalPrice; // Ensure you have the correct total price
    initiatePaymentWithRetry(totalPrice);
  };
  const initiatePaymentWithRetry = async (amount, retryCount = 0) => {
    try {
      const response = await initiatePayment(amount);
      if (response.success) {
        setPaymentStatus("Payment initiation successful!");
        // Handle successful payment initiation (e.g., redirect to success page)
      } else {
        const maxRetries = 50;
        const retryDelay = 1000; // Retry after 5 seconds
        if (retryCount < maxRetries) {
          console.log(
            `Rate limit hit, retrying after ${retryDelay / 1000} seconds...`
          );
          setTimeout(
            () => initiatePaymentWithRetry(amount, retryCount + 1),
            retryDelay
          );
        } else {
          console.error("Max retries reached. Please try again later.");
          setPaymentStatus("Service is busy. Please try again later.");
        }
      }
    } catch (error) {
      if (error) {
        // If a rate limit error is encountered, retry after a delay
        const maxRetries = 50;
        const retryDelay = 1000; // Retry after 5 seconds
        if (retryCount < maxRetries) {
          console.log(
            `Rate limit hit, retrying after ${retryDelay / 1000} seconds...`
          );
          setTimeout(
            () => initiatePaymentWithRetry(amount, retryCount + 1),
            retryDelay
          );
        } else {
          console.error("Max retries reached. Please try again later.");
          setPaymentStatus("Service is busy. Please try again later.");
        }
      } else {
        // Handle other types of errors here
        console.error("Unexpected error during payment initiation:", error);
        setPaymentStatus(
          "An unexpected error occurred. Please contact support."
        );
      }
    } finally {
      setLoading(false); // Ensure loading is set to false after all attempts
    }
  };

  const handleEmailChange = (event) => {
    console.log("this is email:", event.target.value);
    dispatch(setEmail(event.target.value));
  };

  const handleCellphoneChange = (event) => {
    dispatch(setCellphone(event.target.value));
  };

  const handleCountryChange = (event) => {
    dispatch(setCountry(event.target.value));
  };

  const handleNameChange = (event) => {
    dispatch(setName(event.target.value));
  };

  return (
    <form className="form-Style" onSubmit={handleSubmit}>
      <input type="email" placeholder="Email" onChange={handleEmailChange} />
      <input
        type="tel"
        placeholder="cellphone"
        onChange={handleCellphoneChange}
      />
      <input
        type="text"
        placeholder="Country of Origin"
        onChange={handleCountryChange}
      />
      <input type="text" placeholder="name" onChange={handleNameChange} />
      <p>Total Price: N${totalPrice.toFixed(2)}</p>
      {paymentStatus && <p>{paymentStatus}</p>}
      {loading ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ClipLoader size={30} color={"#1C611C"} loading={loading} />
        </div>
      ) : (
        <button className="modern-btn" type="submit">
          BOOK
        </button>
      )}
    </form>
  );
};
export default BookingForm;
